/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Kategoria pytań
 * Kategoria tematyczna sugerowanych pytań
 * @example "TALK_ABOUT_PROPERTY"
 */
export enum QuestionCategory {
  PorozmawiajONieruchomosci = "Porozmawiaj o nieruchomości",
}

export interface SuggestedQuestionRequestDto {
  /**
   * Moduł ogłoszenia
   * Moduł, z którego pochodzi ogłoszenie
   * @example "SALE_FLAT"
   */
  adModule: SuggestedQuestionRequestDtoAdModuleEnum;
  /** Kategoria tematyczna sugerowanych pytań */
  category: QuestionCategory;
}

export interface SuggestedQuestionCategoryDto {
  /**
   * Nazwa kategorii
   * Wyświetlana nazwa kategorii pytań na froncie
   * @example "Porozmawiaj o nieruchomości"
   */
  categoryName: string;
  /**
   * Sugerowane pytania
   * Lista gotowych pytań z danej kategorii
   * @example ["Jakie są dokładne opłaty czynszowe?","Czy mieszkanie wymaga wkładu finansowego?"]
   */
  questions: string[];
}

/**
 * Kontekst ogłoszenia
 * Obiekt przechowujący kontekst konkretnego ogłoszenia (przekazywany, gdy użytkownik zadaje pytanie z poziomu widoku oferty)
 */
export interface AdContextDto {
  /**
   * Unikalny identyfikator ogłoszenia w bazie danych
   * @format int64
   * @example 12345
   */
  adId: number;
  /**
   * Moduł/kategoria, z którego pochodzi ogłoszenie (np. SALE_FLAT, RENT_HOUSE)
   * @example "SALE_FLAT"
   */
  adModule: AdContextDtoAdModuleEnum;
}

export interface ChatBotMessageDto {
  /**
   * Wiadomość
   * Treść wiadomości
   * @minLength 0
   * @maxLength 500
   * @example "Hello"
   */
  message: string;
  /**
   * UUID konwersacji
   * Unikalny identyfikator
   * @format uuid
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  conversationUuid?: string;
  /**
   * Czy oczekuje odpowiedzi audio
   * Jeśli true, bot nie wygeneruje kafelków z filtrami, tylko tekst gotowy do przeczytania przez TTS
   */
  wantsAudioResponse?: boolean;
  /** Obiekt przechowujący kontekst konkretnego ogłoszenia (przekazywany, gdy użytkownik zadaje pytanie z poziomu widoku oferty) */
  adContext?: AdContextDto;
}

export interface SseEmitter {
  /** @format int64 */
  timeout?: number;
}

/**
 * Szczegóły ogłoszenia
 * Kontekst ogłoszenia, którego dotyczy konwersacja
 */
export interface AdContextDetailsDto {
  /**
   * Tytuł ogłoszenia
   * Tytuł ogłoszenia powiązanego z konwersacją
   * @example "Przestronne mieszkanie 50m2"
   */
  advertisementTitle?: string;
  /**
   * URL ogłoszenia
   * URL ogłoszenia powiązanego z konwersacją
   * @example "https://www.otodom.pl/advertisement/123"
   */
  advertisementUrl?: string;
  /**
   * Zaszyfrowane ID
   * Zaszyfrowany identyfikator ogłoszenia w systemie
   * @example "enc12345XYZ"
   */
  encryptedId?: string;
  /**
   * Moduł ogłoszenia
   * Moduł, z jakiego pochodzi ogłoszenie
   * @example "SALE_FLAT"
   */
  adModule?: AdContextDetailsDtoAdModuleEnum;
}

/** Typy nieruchomości */
export enum AuctionBuildingType {
  Mieszkania = "Mieszkania",
  Domy = "Domy",
  Grunty = "Grunty",
  Pozostale = "Pozostałe",
}

/** Typy nieruchomości */
export enum BailiffNoticeBuildingType {
  Mieszkania = "Mieszkania",
  Domy = "Domy",
  Grunty = "Grunty",
  Pozostale = "Pozostałe",
}

/**
 * W jaki sposób są ogłoszenia sortowane
 * @example "DATE_DESC"
 */
export enum BaseSortType {
  DATE_DESC = "DATE_DESC",
  DATE_ASC = "DATE_ASC",
}

/**
 * Nowe wiadomości
 * Lista wiadomości w konwersacji
 */
export interface ChatDetailDto {
  /**
   * UUID konwersacji
   * Unikalny identyfikator
   * @format uuid
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  conversationUuid: string;
  /**
   * Tytuł konwersacji
   * Tytuł konwersacji
   * @example "Chat z botem"
   */
  title: string;
  /**
   * Wiadomości
   * Lista wiadomości w konwersacji
   */
  messages: MessageResponseDto[];
  /** Kontekst ogłoszenia, którego dotyczy konwersacja */
  adDetails?: AdContextDetailsDto;
}

/** Rodzaj budynku */
export enum FlatBuildingType {
  Blok = "Blok",
  Apartamentowiec = "Apartamentowiec",
  Kamienica = "Kamienica",
  Pozostale = "Pozostałe",
}

/** Rodzaj budynku */
export enum HouseBuildingType {
  Wolnostojacy = "Wolnostojący",
  Blizniak = "Bliźniak",
  Szeregowy = "Szeregowy",
  Pozostale = "Pozostałe",
}

/** Lokalizacje kancelarii */
export interface LocationDto {
  /**
   * Id lokalizacji
   * @format int32
   * @example 14
   */
  id?: number;
  /**
   * Pełna nazwa
   * @example "Rybaki"
   */
  fullName?: string;
}

/**
 * Wiadomości
 * Lista wiadomości w konwersacji
 */
export interface MessageResponseDto {
  /**
   * ID wiadomości
   * Unikalny identyfikator wiadomości z bazy danych (potrzebny np. do pobrania audio)
   * @format int64
   * @example 105
   */
  id?: number;
  /**
   * Wiadomość
   * Odpowiedź
   * @example "Wiadomość testowa"
   */
  message: string;
  /**
   * Właściciel wiadomości
   * Właściciel wiadomości
   * @example "USER_MESSAGE"
   */
  messageOwner: MessageResponseDtoMessageOwnerEnum;
  /**
   * Czas utworzenia wiadomości
   * Czas utworzenia wiadomości
   * @format date-time
   */
  createdAt: string;
  /**
   * Czy posiada audio
   * Informacja, czy do tej wiadomości przypisany jest plik głosowy w bazie
   * @example true
   */
  hasAudio?: boolean;
  saleFlatsFilter?: WebSaleFlatFilterDto;
  saleHousesFilter?: WebSaleHouseFilterDto;
  saleOtherFilter?: WebSaleOtherFilterDto;
  salePlotsFilter?: WebSalePlotFilterDto;
  rentFlatsFilter?: WebRentFlatFilterDto;
  rentHousesFilter?: WebRentHouseFilterDto;
  rentOtherFilter?: WebRentOtherFilterDto;
  rentPlotsFilter?: WebRentPlotFilterDto;
  auctionFilter?: WebAuctionFilterDto;
  tenderFilter?: WebTenderFilterDto;
  bailiffNoticeFilter?: WebBailiffNoticeFilterDto;
  cooperativeFilter?: WebCooperativeFilterDto;
  analysisFlatsFilter?: WebSaleAnalysisFlatFilterDto;
  analysisHousesFilter?: WebSaleAnalysisHouseFilterDto;
  analysisOtherFilter?: WebSaleAnalysisOtherFilterDto;
  analysisPlotsFilter?: WebSaleAnalysisPlotFilterDto;
}

export enum Module {
  SALE_FLAT = "SALE_FLAT",
  SALE_HOUSE = "SALE_HOUSE",
  SALE_PLOT = "SALE_PLOT",
  SALE_OTHER = "SALE_OTHER",
  ANALYSIS_SALE_FLAT = "ANALYSIS_SALE_FLAT",
  ANALYSIS_SALE_HOUSE = "ANALYSIS_SALE_HOUSE",
  ANALYSIS_SALE_PLOT = "ANALYSIS_SALE_PLOT",
  ANALYSIS_SALE_OTHER = "ANALYSIS_SALE_OTHER",
  RENT_FLAT = "RENT_FLAT",
  RENT_HOUSE = "RENT_HOUSE",
  RENT_PLOT = "RENT_PLOT",
  RENT_OTHER = "RENT_OTHER",
  AUCTION = "AUCTION",
  BAILIFF_NOTICE = "BAILIFF_NOTICE",
  TENDER = "TENDER",
  COOPERATIVE = "COOPERATIVE",
}

/** Od kogo pochodzi oferta */
export enum OfferFrom {
  OsobaPrywatna = "Osoba prywatna",
  Agencja = "Agencja",
}

/** Rodzaj budynku */
export enum OtherBuildingType {
  Garaze = "Garaże",
  Hale = "Hale",
  Pozostale = "Pozostałe",
}

/** Rodzaj działki */
export enum PlotBuildingType {
  Budowlana = "Budowlana",
  Rolna = "Rolna",
  Lesna = "Leśna",
  Pozostale = "Pozostałe",
}

/**
 * Rodzaj raportu
 * @example "["Przedział czasu"]"
 */
export enum ReportType {
  PrzedzialPowierzchni = "Przedział powierzchni",
  PrzedzialCzasu = "Przedział czasu",
}

export enum SortType {
  DATE_DESC = "DATE_DESC",
  DATE_ASC = "DATE_ASC",
  PRICE_DESC = "PRICE_DESC",
  PRICE_ASC = "PRICE_ASC",
  PRICE_PER_SQUARE_METER_ASC = "PRICE_PER_SQUARE_METER_ASC",
  PRICE_PER_SQUARE_METER_DESC = "PRICE_PER_SQUARE_METER_DESC",
  MODIFICATION_DATE = "MODIFICATION_DATE",
  SCORE_ASC = "SCORE_ASC",
  SCORE_DESC = "SCORE_DESC",
}

/** Typy nieruchomości */
export enum TenderBuildingType {
  Mieszkania = "Mieszkania",
  Domy = "Domy",
  Grunty = "Grunty",
  Pozostale = "Pozostałe",
}

/**
 * Przedział czasowy
 * @example "Kwartał"
 */
export enum TimeRange {
  Rok = "Rok",
  Polrocze = "Półrocze",
  Kwartal = "Kwartał",
  Miesiac = "Miesiąc",
  Tydzien = "Tydzień",
}

/** Typ marketu z którego pochodzi ogłoszenie */
export enum TypeOfMarket {
  Pierwotny = "Pierwotny",
  Wtorny = "Wtórny",
}

export interface WebAuctionFilterDto {
  /**
   * Nazwa filtra
   * @example "Przykładowa nazwa filtra"
   */
  name: string;
  /**
   * Czas opóźnień powiadomień
   * @format int32
   * @default 0
   * @example 720
   */
  notificationsDelay: number;
  /**
   * Powiadomienia sms
   * @example true
   */
  alertSms: boolean;
  /**
   * Powiadomienia email
   * @example true
   */
  alertEmail: boolean;
  /**
   * Powiadomienia push
   * @example true
   */
  alertPush: boolean;
  locations: LocationDto[];
  module: Module;
  /**
   * Pożądane słowa kluczowe
   * Słowa kluczowa brane przy przeszukiwaniu opisu i tytułu
   * @example ["Mieszkanie"]
   */
  wantedKeywords?: string[];
  /**
   * Nie pożądane słowa kluczowe
   * Słowa kluczowa brane przy przeszukiwaniu opisu i tytułu
   * @example ["Mieszkanie"]
   */
  unwantedKeywords?: string[];
  /**
   * Cena od
   * @format double
   * @example 250000
   */
  priceFrom?: number | null;
  /**
   * Cena do
   * @format double
   * @example 5500000
   */
  priceTo?: number | null;
  /**
   * Cena za m2 od
   * @format double
   * @example 2500
   */
  pricePerSquareMeterFrom?: number | null;
  /**
   * Cena za m2 od
   * @format double
   * @example 25000
   */
  pricePerSquareMeterTo?: number | null;
  /**
   * Powierzchnia od
   * @format double
   * @example 250.25
   */
  areaFrom?: number | null;
  /**
   * Powierzchnia do
   * @format double
   * @example 250.55
   */
  areaTo?: number | null;
  /**
   * Rok budowy od
   * @format int32
   * @example 1999
   */
  builtYearFrom?: number | null;
  /**
   * Rok budowy do
   * @format int32
   * @example 2009
   */
  builtYearTo?: number | null;
  /**
   * Piętro od
   * @format int32
   * @example 1
   */
  floorFrom?: number | null;
  /**
   * Piętro do
   * @format int32
   * @example 2
   */
  floorTo?: number | null;
  /**
   * Liczba pięter od
   * @format int32
   * @example 1
   */
  floorsFrom?: number | null;
  /**
   * Liczba pięter do
   * @format int32
   * @example 2
   */
  floorsTo?: number | null;
  /**
   * Liczba pokoi od
   * @format int32
   * @example 1
   */
  numberOfRoomsFrom?: number | null;
  /**
   * Liczba pokoi do
   * @format int32
   * @example 2
   */
  numberOfRoomsTo?: number | null;
  /** Typy nieruchomości */
  types?: AuctionBuildingType[];
  /**
   * Ogłoszenia z liczby dni
   * @format int32
   * @min 1
   * @example 3
   */
  daysAmount: number;
  /**
   * Data dodania od
   * @format date
   * @example "2024-01-01"
   */
  dateAddedFrom: string;
  /**
   * Data dodania do
   * @format date
   * @example "2024-01-04"
   */
  dateAddedTo?: string;
  /**
   * Akceptuj puste wartości
   * @example true
   */
  includeZeroArea: boolean;
  sortType?: BaseSortType;
}

export interface WebBailiffNoticeFilterDto {
  /**
   * Nazwa filtra
   * @example "Przykładowa nazwa filtra"
   */
  name: string;
  /**
   * Czas opóźnień powiadomień
   * @format int32
   * @default 0
   * @example 720
   */
  notificationsDelay: number;
  /**
   * Powiadomienia sms
   * @example true
   */
  alertSms: boolean;
  /**
   * Powiadomienia email
   * @example true
   */
  alertEmail: boolean;
  /**
   * Powiadomienia push
   * @example true
   */
  alertPush: boolean;
  locations: LocationDto[];
  module: Module;
  /**
   * Pożądane słowa kluczowe
   * Słowa kluczowa brane przy przeszukiwaniu opisu i tytułu
   * @example ["Mieszkanie"]
   */
  wantedKeywords?: string[];
  /**
   * Nie pożądane słowa kluczowe
   * Słowa kluczowa brane przy przeszukiwaniu opisu i tytułu
   * @example ["Mieszkanie"]
   */
  unwantedKeywords?: string[];
  /** Lokalizacje kancelarii */
  officeLocations?: LocationDto[];
  /** Typy nieruchomości */
  types?: BailiffNoticeBuildingType[] | null;
  /**
   * Ogłoszenia z liczby dni
   * @format int32
   * @min 1
   * @example 3
   */
  daysAmount?: number | null;
  /**
   * Data dodania od
   * @format date
   * @example "2024-01-01"
   */
  dateAddedFrom?: string | null;
  /**
   * Data dodania do
   * @format date
   * @example "2024-01-04"
   */
  dateAddedTo?: string | null;
  /**
   * Akceptuj puste wartości
   * @example true
   */
  includeZeroArea?: boolean | null;
  sortType?: BaseSortType;
}

export interface WebCooperativeFilterDto {
  /**
   * Nazwa filtra
   * @example "Przykładowa nazwa filtra"
   */
  name: string;
  /**
   * Czas opóźnień powiadomień
   * @format int32
   * @default 0
   * @example 720
   */
  notificationsDelay: number;
  /**
   * Powiadomienia sms
   * @example true
   */
  alertSms: boolean;
  /**
   * Powiadomienia email
   * @example true
   */
  alertEmail: boolean;
  /**
   * Powiadomienia push
   * @example true
   */
  alertPush: boolean;
  locations: LocationDto[];
  module: Module;
  /**
   * Pożądane słowa kluczowe
   * Słowa kluczowa brane przy przeszukiwaniu opisu i tytułu
   * @example ["Mieszkanie"]
   */
  wantedKeywords?: string[];
  /**
   * Nie pożądane słowa kluczowe
   * Słowa kluczowa brane przy przeszukiwaniu opisu i tytułu
   * @example ["Mieszkanie"]
   */
  unwantedKeywords?: string[];
  /**
   * Ogłoszenia z liczby dni
   * @format int32
   * @min 1
   * @example 3
   */
  daysAmount?: number | null;
  /**
   * Data dodania od
   * @format date
   * @example "2024-01-01"
   */
  dateAddedFrom?: string | null;
  /**
   * Data dodania do
   * @format date
   * @example "2024-01-04"
   */
  dateAddedTo?: string | null;
  sortType?: BaseSortType;
}

export interface WebRentFlatFilterDto {
  /**
   * Nazwa filtra
   * @example "Przykładowa nazwa filtra"
   */
  name: string;
  /**
   * Czas opóźnień powiadomień
   * @format int32
   * @default 0
   * @example 720
   */
  notificationsDelay: number;
  /**
   * Powiadomienia sms
   * @example true
   */
  alertSms: boolean;
  /**
   * Powiadomienia email
   * @example true
   */
  alertEmail: boolean;
  /**
   * Powiadomienia push
   * @example true
   */
  alertPush: boolean;
  locations: LocationDto[];
  module: Module;
  /**
   * Pożądane słowa kluczowe
   * Słowa kluczowa brane przy przeszukiwaniu opisu i tytułu
   * @example ["Mieszkanie"]
   */
  wantedKeywords?: string[];
  /**
   * Nie pożądane słowa kluczowe
   * Słowa kluczowa brane przy przeszukiwaniu opisu i tytułu
   * @example ["Mieszkanie"]
   */
  unwantedKeywords?: string[];
  /**
   * Powierzchnia nieruchomości od
   * @format double
   * @min 0
   * @example 100
   */
  areaFrom?: number;
  /**
   * Powierzchnia nieruchomości do
   * @format double
   * @min 0
   * @example 200
   */
  areaTo?: number;
  /**
   * Cena za metr kwadratowy od
   * @format double
   * @min 0
   * @example 100
   */
  pricePerSquareMeterFrom?: number;
  /**
   * Cena za metr kwadratowy do
   * @format double
   * @min 0
   * @example 200
   */
  pricePerSquareMeterTo?: number;
  /**
   * Cena wynajmu nieruchomości od
   * @format double
   * @min 0
   * @example 1000000
   */
  priceFrom?: number;
  /**
   * Cena wynajmu nieruchomości do
   * @format double
   * @min 0
   * @example 2000000
   */
  priceTo?: number;
  /**
   * Cena czynszu nieruchomości od
   * @format double
   * @min 0
   * @example 3000
   */
  depositPriceFrom?: number;
  /**
   * Cena czynszu nieruchomości do
   * @format double
   * @min 0
   * @example 5000
   */
  depositPriceTo?: number;
  /**
   * Cena kaucji nieruchomości od
   * @format double
   * @min 0
   * @example 1000
   */
  rentPriceFrom?: number;
  /**
   * Cena kaucji nieruchomości do
   * @format double
   * @min 0
   * @example 2000
   */
  rentPriceTo?: number;
  /** Od kogo pochodzi oferta */
  offerFrom?: OfferFrom[];
  /**
   * Wartości zerowe
   * @example true
   */
  includeZeroArea: boolean;
  /**
   * Modyfikacje ogłoszenia
   * @example true
   */
  modification: boolean;
  /**
   * Podbicie ogłoszenia
   * @example true
   */
  tossedUp: boolean;
  /**
   * Grupowanie duplikatów
   * @example true
   */
  groupDuplicate: boolean;
  /**
   * Data dodania od
   * Czas w formacie LocalDate
   * @format date
   * @example "2023-12-12"
   */
  offerAddedFrom: string;
  /**
   * Data dodania do
   * Czas w formacie LocalDate
   * @format date
   * @example "2023-12-12"
   */
  offerAddedTo?: string;
  /**
   * Ogłoszenia z liczby dni
   * @format int32
   * @example 7
   */
  daysAmount: number;
  sortType: SortType;
  unlockedAdvertisements: boolean;
  lowerOriginalPrice: boolean;
  /**
   * Pożądane numery telefonów
   * @example ["123467890"]
   */
  wantedPhoneNumbers?: string[];
  /**
   * Nie pożądane numery telefonów
   * @example ["123467890"]
   */
  unwantedPhoneNumbers?: string[];
  /**
   * Liczba pokoi w mieszkaniu od
   * @format int32
   * @min 0
   * @example 1
   */
  numberOfRoomsFrom?: number;
  /**
   * Liczba pokoi w mieszkaniu do
   * @format int32
   * @min 0
   * @example 3
   */
  numberOfRoomsTo?: number;
  /**
   * Rok budowy nieruchomości od
   * @format int32
   * @min 1800
   * @example 2012
   */
  builtYearFrom?: number;
  /**
   * Rok budowy nieruchomości do
   * @format int32
   * @max 2030
   * @example 2018
   */
  builtYearTo?: number;
  /** Typ marketu z którego pochodzi ogłoszenie */
  typeOfMarket?: TypeOfMarket[];
  /** Rodzaj budynku */
  buildingType?: FlatBuildingType[];
  /**
   * Piętro na którym jest mieszkanie od
   * @format int32
   * @example 4
   */
  floorFrom?: number;
  /**
   * Piętro na którym jest mieszkanie do
   * @format int32
   * @example 4
   */
  floorTo?: number;
  /**
   * Piętra w budynku od
   * @format int32
   * @example 4
   */
  floorsFrom?: number;
  /**
   * Piętra w budynku do
   * @format int32
   * @example 4
   */
  floorsTo?: number;
}

export interface WebRentHouseFilterDto {
  /**
   * Nazwa filtra
   * @example "Przykładowa nazwa filtra"
   */
  name: string;
  /**
   * Czas opóźnień powiadomień
   * @format int32
   * @default 0
   * @example 720
   */
  notificationsDelay: number;
  /**
   * Powiadomienia sms
   * @example true
   */
  alertSms: boolean;
  /**
   * Powiadomienia email
   * @example true
   */
  alertEmail: boolean;
  /**
   * Powiadomienia push
   * @example true
   */
  alertPush: boolean;
  locations: LocationDto[];
  module: Module;
  /**
   * Pożądane słowa kluczowe
   * Słowa kluczowa brane przy przeszukiwaniu opisu i tytułu
   * @example ["Mieszkanie"]
   */
  wantedKeywords?: string[];
  /**
   * Nie pożądane słowa kluczowe
   * Słowa kluczowa brane przy przeszukiwaniu opisu i tytułu
   * @example ["Mieszkanie"]
   */
  unwantedKeywords?: string[];
  /**
   * Powierzchnia nieruchomości od
   * @format double
   * @min 0
   * @example 100
   */
  areaFrom?: number;
  /**
   * Powierzchnia nieruchomości do
   * @format double
   * @min 0
   * @example 200
   */
  areaTo?: number;
  /**
   * Cena za metr kwadratowy od
   * @format double
   * @min 0
   * @example 100
   */
  pricePerSquareMeterFrom?: number;
  /**
   * Cena za metr kwadratowy do
   * @format double
   * @min 0
   * @example 200
   */
  pricePerSquareMeterTo?: number;
  /**
   * Cena wynajmu nieruchomości od
   * @format double
   * @min 0
   * @example 1000000
   */
  priceFrom?: number;
  /**
   * Cena wynajmu nieruchomości do
   * @format double
   * @min 0
   * @example 2000000
   */
  priceTo?: number;
  /**
   * Cena czynszu nieruchomości od
   * @format double
   * @min 0
   * @example 3000
   */
  depositPriceFrom?: number;
  /**
   * Cena czynszu nieruchomości do
   * @format double
   * @min 0
   * @example 5000
   */
  depositPriceTo?: number;
  /**
   * Cena kaucji nieruchomości od
   * @format double
   * @min 0
   * @example 1000
   */
  rentPriceFrom?: number;
  /**
   * Cena kaucji nieruchomości do
   * @format double
   * @min 0
   * @example 2000
   */
  rentPriceTo?: number;
  /** Od kogo pochodzi oferta */
  offerFrom?: OfferFrom[];
  /**
   * Wartości zerowe
   * @example true
   */
  includeZeroArea: boolean;
  /**
   * Modyfikacje ogłoszenia
   * @example true
   */
  modification: boolean;
  /**
   * Podbicie ogłoszenia
   * @example true
   */
  tossedUp: boolean;
  /**
   * Grupowanie duplikatów
   * @example true
   */
  groupDuplicate: boolean;
  /**
   * Data dodania od
   * Czas w formacie LocalDate
   * @format date
   * @example "2023-12-12"
   */
  offerAddedFrom: string;
  /**
   * Data dodania do
   * Czas w formacie LocalDate
   * @format date
   * @example "2023-12-12"
   */
  offerAddedTo?: string;
  /**
   * Ogłoszenia z liczby dni
   * @format int32
   * @example 7
   */
  daysAmount: number;
  sortType: SortType;
  unlockedAdvertisements: boolean;
  lowerOriginalPrice: boolean;
  /**
   * Pożądane numery telefonów
   * @example ["123467890"]
   */
  wantedPhoneNumbers?: string[];
  /**
   * Nie pożądane numery telefonów
   * @example ["123467890"]
   */
  unwantedPhoneNumbers?: string[];
  /**
   * Liczba pokoi w domu od
   * @format int32
   * @min 0
   * @example 3
   */
  numberOfRoomsFrom?: number;
  /**
   * Liczba pokoi w domu do
   * @format int32
   * @min 0
   * @example 5
   */
  numberOfRoomsTo?: number;
  /**
   * Rok budowy nieruchomości od
   * @format int32
   * @min 1800
   * @example 2012
   */
  builtYearFrom?: number;
  /**
   * Rok budowy nieruchomości do
   * @format int32
   * @max 2030
   * @example 2018
   */
  builtYearTo?: number;
  /** Typ marketu z którego pochodzi ogłoszenie */
  typeOfMarket?: TypeOfMarket[];
  /** Rodzaj budynku */
  buildingType?: HouseBuildingType[];
  /**
   * Liczba pieter od
   * Pojedynczy wybór
   * @format int32
   * @example 0
   */
  floorFrom?: null;
  /**
   * Liczba pieter do
   * Pojedynczy wybór
   * @format int32
   * @example 2
   */
  floorTo?: null;
}

export interface WebRentOtherFilterDto {
  /**
   * Nazwa filtra
   * @example "Przykładowa nazwa filtra"
   */
  name: string;
  /**
   * Czas opóźnień powiadomień
   * @format int32
   * @default 0
   * @example 720
   */
  notificationsDelay: number;
  /**
   * Powiadomienia sms
   * @example true
   */
  alertSms: boolean;
  /**
   * Powiadomienia email
   * @example true
   */
  alertEmail: boolean;
  /**
   * Powiadomienia push
   * @example true
   */
  alertPush: boolean;
  locations: LocationDto[];
  module: Module;
  /**
   * Pożądane słowa kluczowe
   * Słowa kluczowa brane przy przeszukiwaniu opisu i tytułu
   * @example ["Mieszkanie"]
   */
  wantedKeywords?: string[];
  /**
   * Nie pożądane słowa kluczowe
   * Słowa kluczowa brane przy przeszukiwaniu opisu i tytułu
   * @example ["Mieszkanie"]
   */
  unwantedKeywords?: string[];
  /**
   * Powierzchnia nieruchomości od
   * @format double
   * @min 0
   * @example 100
   */
  areaFrom?: number;
  /**
   * Powierzchnia nieruchomości do
   * @format double
   * @min 0
   * @example 200
   */
  areaTo?: number;
  /**
   * Cena za metr kwadratowy od
   * @format double
   * @min 0
   * @example 100
   */
  pricePerSquareMeterFrom?: number;
  /**
   * Cena za metr kwadratowy do
   * @format double
   * @min 0
   * @example 200
   */
  pricePerSquareMeterTo?: number;
  /**
   * Cena wynajmu nieruchomości od
   * @format double
   * @min 0
   * @example 1000000
   */
  priceFrom?: number;
  /**
   * Cena wynajmu nieruchomości do
   * @format double
   * @min 0
   * @example 2000000
   */
  priceTo?: number;
  /**
   * Cena czynszu nieruchomości od
   * @format double
   * @min 0
   * @example 3000
   */
  depositPriceFrom?: number;
  /**
   * Cena czynszu nieruchomości do
   * @format double
   * @min 0
   * @example 5000
   */
  depositPriceTo?: number;
  /**
   * Cena kaucji nieruchomości od
   * @format double
   * @min 0
   * @example 1000
   */
  rentPriceFrom?: number;
  /**
   * Cena kaucji nieruchomości do
   * @format double
   * @min 0
   * @example 2000
   */
  rentPriceTo?: number;
  /** Od kogo pochodzi oferta */
  offerFrom?: OfferFrom[];
  /**
   * Wartości zerowe
   * @example true
   */
  includeZeroArea: boolean;
  /**
   * Modyfikacje ogłoszenia
   * @example true
   */
  modification: boolean;
  /**
   * Podbicie ogłoszenia
   * @example true
   */
  tossedUp: boolean;
  /**
   * Grupowanie duplikatów
   * @example true
   */
  groupDuplicate: boolean;
  /**
   * Data dodania od
   * Czas w formacie LocalDate
   * @format date
   * @example "2023-12-12"
   */
  offerAddedFrom: string;
  /**
   * Data dodania do
   * Czas w formacie LocalDate
   * @format date
   * @example "2023-12-12"
   */
  offerAddedTo?: string;
  /**
   * Ogłoszenia z liczby dni
   * @format int32
   * @example 7
   */
  daysAmount: number;
  sortType: SortType;
  unlockedAdvertisements: boolean;
  lowerOriginalPrice: boolean;
  /**
   * Pożądane numery telefonów
   * @example ["123467890"]
   */
  wantedPhoneNumbers?: string[];
  /**
   * Nie pożądane numery telefonów
   * @example ["123467890"]
   */
  unwantedPhoneNumbers?: string[];
  /**
   * Rok budowy nieruchomości od
   * @format int32
   * @min 1800
   * @example 2012
   */
  builtYearFrom?: number;
  /**
   * Rok budowy nieruchomości do
   * @format int32
   * @max 2030
   * @example 2018
   */
  builtYearTo?: number;
  /**
   * Piętro od
   * @format int32
   * @example 4
   */
  floorFrom?: number;
  /**
   * Piętro do
   * @format int32
   * @example 4
   */
  floorTo?: number;
  /** Typ marketu z którego pochodzi ogłoszenie */
  typeOfMarket?: TypeOfMarket[];
  /** Rodzaj budynku */
  buildingType?: OtherBuildingType[];
}

export interface WebRentPlotFilterDto {
  /**
   * Nazwa filtra
   * @example "Przykładowa nazwa filtra"
   */
  name: string;
  /**
   * Czas opóźnień powiadomień
   * @format int32
   * @default 0
   * @example 720
   */
  notificationsDelay: number;
  /**
   * Powiadomienia sms
   * @example true
   */
  alertSms: boolean;
  /**
   * Powiadomienia email
   * @example true
   */
  alertEmail: boolean;
  /**
   * Powiadomienia push
   * @example true
   */
  alertPush: boolean;
  locations: LocationDto[];
  module: Module;
  /**
   * Pożądane słowa kluczowe
   * Słowa kluczowa brane przy przeszukiwaniu opisu i tytułu
   * @example ["Mieszkanie"]
   */
  wantedKeywords?: string[];
  /**
   * Nie pożądane słowa kluczowe
   * Słowa kluczowa brane przy przeszukiwaniu opisu i tytułu
   * @example ["Mieszkanie"]
   */
  unwantedKeywords?: string[];
  /**
   * Powierzchnia nieruchomości od
   * @format double
   * @min 0
   * @example 100
   */
  areaFrom?: number;
  /**
   * Powierzchnia nieruchomości do
   * @format double
   * @min 0
   * @example 200
   */
  areaTo?: number;
  /**
   * Cena za metr kwadratowy od
   * @format double
   * @min 0
   * @example 100
   */
  pricePerSquareMeterFrom?: number;
  /**
   * Cena za metr kwadratowy do
   * @format double
   * @min 0
   * @example 200
   */
  pricePerSquareMeterTo?: number;
  /**
   * Cena wynajmu nieruchomości od
   * @format double
   * @min 0
   * @example 1000000
   */
  priceFrom?: number;
  /**
   * Cena wynajmu nieruchomości do
   * @format double
   * @min 0
   * @example 2000000
   */
  priceTo?: number;
  /**
   * Cena czynszu nieruchomości od
   * @format double
   * @min 0
   * @example 3000
   */
  depositPriceFrom?: number;
  /**
   * Cena czynszu nieruchomości do
   * @format double
   * @min 0
   * @example 5000
   */
  depositPriceTo?: number;
  /**
   * Cena kaucji nieruchomości od
   * @format double
   * @min 0
   * @example 1000
   */
  rentPriceFrom?: number;
  /**
   * Cena kaucji nieruchomości do
   * @format double
   * @min 0
   * @example 2000
   */
  rentPriceTo?: number;
  /** Od kogo pochodzi oferta */
  offerFrom?: OfferFrom[];
  /**
   * Wartości zerowe
   * @example true
   */
  includeZeroArea: boolean;
  /**
   * Modyfikacje ogłoszenia
   * @example true
   */
  modification: boolean;
  /**
   * Podbicie ogłoszenia
   * @example true
   */
  tossedUp: boolean;
  /**
   * Grupowanie duplikatów
   * @example true
   */
  groupDuplicate: boolean;
  /**
   * Data dodania od
   * Czas w formacie LocalDate
   * @format date
   * @example "2023-12-12"
   */
  offerAddedFrom: string;
  /**
   * Data dodania do
   * Czas w formacie LocalDate
   * @format date
   * @example "2023-12-12"
   */
  offerAddedTo?: string;
  /**
   * Ogłoszenia z liczby dni
   * @format int32
   * @example 7
   */
  daysAmount: number;
  sortType: SortType;
  unlockedAdvertisements: boolean;
  lowerOriginalPrice: boolean;
  /**
   * Pożądane numery telefonów
   * @example ["123467890"]
   */
  wantedPhoneNumbers?: string[];
  /**
   * Nie pożądane numery telefonów
   * @example ["123467890"]
   */
  unwantedPhoneNumbers?: string[];
  /** Rodzaj działki */
  buildingType?: PlotBuildingType[];
}

export interface WebSaleAnalysisFlatFilterDto {
  /**
   * Nazwa filtra
   * @example "Przykładowa nazwa filtra"
   */
  name: string;
  /**
   * Czas opóźnień powiadomień
   * @format int32
   * @default 0
   * @example 720
   */
  notificationsDelay: number;
  /**
   * Powiadomienia sms
   * @example true
   */
  alertSms: boolean;
  /**
   * Powiadomienia email
   * @example true
   */
  alertEmail: boolean;
  /**
   * Powiadomienia push
   * @example true
   */
  alertPush: boolean;
  locations: LocationDto[];
  module: Module;
  /**
   * Pożądane słowa kluczowe
   * Słowa kluczowa brane przy przeszukiwaniu opisu i tytułu
   * @example ["Mieszkanie"]
   */
  wantedKeywords?: string[];
  /**
   * Nie pożądane słowa kluczowe
   * Słowa kluczowa brane przy przeszukiwaniu opisu i tytułu
   * @example ["Mieszkanie"]
   */
  unwantedKeywords?: string[];
  /**
   * Powierzchnia nieruchomości od
   * @format double
   * @min 0
   * @example 100
   */
  areaFrom?: number;
  /**
   * Powierzchnia nieruchomości do
   * @format double
   * @min 0
   * @example 200
   */
  areaTo?: number;
  /**
   * Cena za metr kwadratowy od
   * @format double
   * @min 0
   * @example 100
   */
  pricePerSquareMeterFrom?: number;
  /**
   * Cena za metr kwadratowy do
   * @format double
   * @min 0
   * @example 200
   */
  pricePerSquareMeterTo?: number;
  /**
   * Cena nieruchomości od
   * @format double
   * @min 0
   * @example 1000000
   */
  priceFrom?: number;
  /**
   * Cena nieruchomości do
   * @format double
   * @min 0
   * @example 2000000
   */
  priceTo?: number;
  /** Od kogo pochodzi oferta */
  offerFrom?: OfferFrom[];
  /**
   * Wartości zerowe
   * @example true
   */
  includeZeroArea: boolean;
  /**
   * Modyfikacje ogłoszenia
   * @example true
   */
  modification: boolean;
  /**
   * Podbicie ogłoszenia
   * @example true
   */
  tossedUp: boolean;
  /**
   * Grupowanie duplikatów
   * @example true
   */
  groupDuplicate: boolean;
  /**
   * Data dodania od
   * Czas w formacie LocalDate
   * @format date
   * @example "2023-12-12"
   */
  offerAddedFrom: string;
  /**
   * Data dodania do
   * Czas w formacie LocalDate
   * @format date
   * @example "2023-12-12"
   */
  offerAddedTo?: string;
  /**
   * Ogłoszenia z liczby dni
   * @format int32
   * @example 7
   */
  daysAmount: number;
  sortType: SortType;
  unlockedAdvertisements: boolean;
  lowerOriginalPrice: boolean;
  /**
   * Pożądane numery telefonów
   * @example ["123467890"]
   */
  wantedPhoneNumbers?: string[];
  /**
   * Nie pożądane numery telefonów
   * @example ["123467890"]
   */
  unwantedPhoneNumbers?: string[];
  /**
   * Liczba pokoi w mieszkaniu od
   * @format int32
   * @min 0
   * @example 1
   */
  numberOfRoomsFrom?: number;
  /**
   * Liczba pokoi w mieszkaniu do
   * @format int32
   * @min 0
   * @example 3
   */
  numberOfRoomsTo?: number;
  /**
   * Rok budowy nieruchomości od
   * @format int32
   * @min 1800
   * @example 2012
   */
  builtYearFrom?: number;
  /**
   * Rok budowy nieruchomości do
   * @format int32
   * @max 2030
   * @example 2018
   */
  builtYearTo?: number;
  /** Typ marketu z którego pochodzi ogłoszenie */
  typeOfMarket?: TypeOfMarket[];
  /** Rodzaj budynku */
  buildingType?: FlatBuildingType[];
  /**
   * Piętro na którym jest mieszkanie od
   * @format int32
   * @example 4
   */
  floorFrom?: number;
  /**
   * Piętro na którym jest mieszkanie do
   * @format int32
   * @example 4
   */
  floorTo?: number;
  /**
   * Piętra w budynku od
   * @format int32
   * @example 4
   */
  floorsFrom?: number;
  /**
   * Piętra w budynku do
   * @format int32
   * @example 4
   */
  floorsTo?: number;
  timeRange: TimeRange;
  /**
   * Rodzaj raportu
   * @example ["Przedział czasu"]
   */
  reportType: ReportType[];
  /**
   * Granice przedziałów [m2]
   * @example "15,35,50,70,100,#"
   */
  boundaries: string;
}

export interface WebSaleAnalysisHouseFilterDto {
  /**
   * Nazwa filtra
   * @example "Przykładowa nazwa filtra"
   */
  name: string;
  /**
   * Czas opóźnień powiadomień
   * @format int32
   * @default 0
   * @example 720
   */
  notificationsDelay: number;
  /**
   * Powiadomienia sms
   * @example true
   */
  alertSms: boolean;
  /**
   * Powiadomienia email
   * @example true
   */
  alertEmail: boolean;
  /**
   * Powiadomienia push
   * @example true
   */
  alertPush: boolean;
  locations: LocationDto[];
  module: Module;
  /**
   * Pożądane słowa kluczowe
   * Słowa kluczowa brane przy przeszukiwaniu opisu i tytułu
   * @example ["Mieszkanie"]
   */
  wantedKeywords?: string[];
  /**
   * Nie pożądane słowa kluczowe
   * Słowa kluczowa brane przy przeszukiwaniu opisu i tytułu
   * @example ["Mieszkanie"]
   */
  unwantedKeywords?: string[];
  /**
   * Powierzchnia nieruchomości od
   * @format double
   * @min 0
   * @example 100
   */
  areaFrom?: number;
  /**
   * Powierzchnia nieruchomości do
   * @format double
   * @min 0
   * @example 200
   */
  areaTo?: number;
  /**
   * Cena za metr kwadratowy od
   * @format double
   * @min 0
   * @example 100
   */
  pricePerSquareMeterFrom?: number;
  /**
   * Cena za metr kwadratowy do
   * @format double
   * @min 0
   * @example 200
   */
  pricePerSquareMeterTo?: number;
  /**
   * Cena nieruchomości od
   * @format double
   * @min 0
   * @example 1000000
   */
  priceFrom?: number;
  /**
   * Cena nieruchomości do
   * @format double
   * @min 0
   * @example 2000000
   */
  priceTo?: number;
  /** Od kogo pochodzi oferta */
  offerFrom?: OfferFrom[];
  /**
   * Wartości zerowe
   * @example true
   */
  includeZeroArea: boolean;
  /**
   * Modyfikacje ogłoszenia
   * @example true
   */
  modification: boolean;
  /**
   * Podbicie ogłoszenia
   * @example true
   */
  tossedUp: boolean;
  /**
   * Grupowanie duplikatów
   * @example true
   */
  groupDuplicate: boolean;
  /**
   * Data dodania od
   * Czas w formacie LocalDate
   * @format date
   * @example "2023-12-12"
   */
  offerAddedFrom: string;
  /**
   * Data dodania do
   * Czas w formacie LocalDate
   * @format date
   * @example "2023-12-12"
   */
  offerAddedTo?: string;
  /**
   * Ogłoszenia z liczby dni
   * @format int32
   * @example 7
   */
  daysAmount: number;
  sortType: SortType;
  unlockedAdvertisements: boolean;
  lowerOriginalPrice: boolean;
  /**
   * Pożądane numery telefonów
   * @example ["123467890"]
   */
  wantedPhoneNumbers?: string[];
  /**
   * Nie pożądane numery telefonów
   * @example ["123467890"]
   */
  unwantedPhoneNumbers?: string[];
  /**
   * Liczba pokoi w domu od
   * @format int32
   * @min 0
   * @example 3
   */
  numberOfRoomsFrom?: number;
  /**
   * Liczba pokoi w domu do
   * @format int32
   * @min 0
   * @example 5
   */
  numberOfRoomsTo?: number;
  /**
   * Rok budowy nieruchomości od
   * @format int32
   * @min 1800
   * @example 2012
   */
  builtYearFrom?: number;
  /**
   * Rok budowy nieruchomości do
   * @format int32
   * @max 2030
   * @example 2018
   */
  builtYearTo?: number;
  /** Typ marketu z którego pochodzi ogłoszenie */
  typeOfMarket?: TypeOfMarket[];
  /** Rodzaj budynku */
  buildingType?: HouseBuildingType[];
  /**
   * Liczba pieter od
   * Pojedynczy wybór
   * @format int32
   * @example 0
   */
  floorFrom?: null;
  /**
   * Liczba pieter do
   * Pojedynczy wybór
   * @format int32
   * @example 2
   */
  floorTo?: null;
  timeRange: TimeRange;
  /**
   * Rodzaj raportu
   * @example ["Przedział czasu"]
   */
  reportType: ReportType[];
  /**
   * Granice przedziałów [m2]
   * @example "15,35,50,70,100,#"
   */
  boundaries: string;
}

export interface WebSaleAnalysisOtherFilterDto {
  /**
   * Nazwa filtra
   * @example "Przykładowa nazwa filtra"
   */
  name: string;
  /**
   * Czas opóźnień powiadomień
   * @format int32
   * @default 0
   * @example 720
   */
  notificationsDelay: number;
  /**
   * Powiadomienia sms
   * @example true
   */
  alertSms: boolean;
  /**
   * Powiadomienia email
   * @example true
   */
  alertEmail: boolean;
  /**
   * Powiadomienia push
   * @example true
   */
  alertPush: boolean;
  locations: LocationDto[];
  module: Module;
  /**
   * Pożądane słowa kluczowe
   * Słowa kluczowa brane przy przeszukiwaniu opisu i tytułu
   * @example ["Mieszkanie"]
   */
  wantedKeywords?: string[];
  /**
   * Nie pożądane słowa kluczowe
   * Słowa kluczowa brane przy przeszukiwaniu opisu i tytułu
   * @example ["Mieszkanie"]
   */
  unwantedKeywords?: string[];
  /**
   * Powierzchnia nieruchomości od
   * @format double
   * @min 0
   * @example 100
   */
  areaFrom?: number;
  /**
   * Powierzchnia nieruchomości do
   * @format double
   * @min 0
   * @example 200
   */
  areaTo?: number;
  /**
   * Cena za metr kwadratowy od
   * @format double
   * @min 0
   * @example 100
   */
  pricePerSquareMeterFrom?: number;
  /**
   * Cena za metr kwadratowy do
   * @format double
   * @min 0
   * @example 200
   */
  pricePerSquareMeterTo?: number;
  /**
   * Cena nieruchomości od
   * @format double
   * @min 0
   * @example 1000000
   */
  priceFrom?: number;
  /**
   * Cena nieruchomości do
   * @format double
   * @min 0
   * @example 2000000
   */
  priceTo?: number;
  /** Od kogo pochodzi oferta */
  offerFrom?: OfferFrom[];
  /**
   * Wartości zerowe
   * @example true
   */
  includeZeroArea: boolean;
  /**
   * Modyfikacje ogłoszenia
   * @example true
   */
  modification: boolean;
  /**
   * Podbicie ogłoszenia
   * @example true
   */
  tossedUp: boolean;
  /**
   * Grupowanie duplikatów
   * @example true
   */
  groupDuplicate: boolean;
  /**
   * Data dodania od
   * Czas w formacie LocalDate
   * @format date
   * @example "2023-12-12"
   */
  offerAddedFrom: string;
  /**
   * Data dodania do
   * Czas w formacie LocalDate
   * @format date
   * @example "2023-12-12"
   */
  offerAddedTo?: string;
  /**
   * Ogłoszenia z liczby dni
   * @format int32
   * @example 7
   */
  daysAmount: number;
  sortType: SortType;
  unlockedAdvertisements: boolean;
  lowerOriginalPrice: boolean;
  /**
   * Pożądane numery telefonów
   * @example ["123467890"]
   */
  wantedPhoneNumbers?: string[];
  /**
   * Nie pożądane numery telefonów
   * @example ["123467890"]
   */
  unwantedPhoneNumbers?: string[];
  /**
   * Rok budowy nieruchomości od
   * @format int32
   * @min 1800
   * @example 2012
   */
  builtYearFrom?: number;
  /**
   * Rok budowy nieruchomości do
   * @format int32
   * @max 2030
   * @example 2018
   */
  builtYearTo?: number;
  /**
   * Piętro od
   * @format int32
   * @example 4
   */
  floorFrom?: number;
  /**
   * Piętro do
   * @format int32
   * @example 4
   */
  floorTo?: number;
  /** Typ marketu z którego pochodzi ogłoszenie */
  typeOfMarket?: TypeOfMarket[];
  /** Rodzaj budynku */
  buildingType?: OtherBuildingType[];
  timeRange: TimeRange;
  /**
   * Rodzaj raportu
   * @example ["Przedział czasu"]
   */
  reportType: ReportType[];
  /**
   * Granice przedziałów [m2]
   * @example "15,35,50,70,100,#"
   */
  boundaries: string;
}

export interface WebSaleAnalysisPlotFilterDto {
  /**
   * Nazwa filtra
   * @example "Przykładowa nazwa filtra"
   */
  name: string;
  /**
   * Czas opóźnień powiadomień
   * @format int32
   * @default 0
   * @example 720
   */
  notificationsDelay: number;
  /**
   * Powiadomienia sms
   * @example true
   */
  alertSms: boolean;
  /**
   * Powiadomienia email
   * @example true
   */
  alertEmail: boolean;
  /**
   * Powiadomienia push
   * @example true
   */
  alertPush: boolean;
  locations: LocationDto[];
  module: Module;
  /**
   * Pożądane słowa kluczowe
   * Słowa kluczowa brane przy przeszukiwaniu opisu i tytułu
   * @example ["Mieszkanie"]
   */
  wantedKeywords?: string[];
  /**
   * Nie pożądane słowa kluczowe
   * Słowa kluczowa brane przy przeszukiwaniu opisu i tytułu
   * @example ["Mieszkanie"]
   */
  unwantedKeywords?: string[];
  /**
   * Powierzchnia nieruchomości od
   * @format double
   * @min 0
   * @example 100
   */
  areaFrom?: number;
  /**
   * Powierzchnia nieruchomości do
   * @format double
   * @min 0
   * @example 200
   */
  areaTo?: number;
  /**
   * Cena za metr kwadratowy od
   * @format double
   * @min 0
   * @example 100
   */
  pricePerSquareMeterFrom?: number;
  /**
   * Cena za metr kwadratowy do
   * @format double
   * @min 0
   * @example 200
   */
  pricePerSquareMeterTo?: number;
  /**
   * Cena nieruchomości od
   * @format double
   * @min 0
   * @example 1000000
   */
  priceFrom?: number;
  /**
   * Cena nieruchomości do
   * @format double
   * @min 0
   * @example 2000000
   */
  priceTo?: number;
  /** Od kogo pochodzi oferta */
  offerFrom?: OfferFrom[];
  /**
   * Wartości zerowe
   * @example true
   */
  includeZeroArea: boolean;
  /**
   * Modyfikacje ogłoszenia
   * @example true
   */
  modification: boolean;
  /**
   * Podbicie ogłoszenia
   * @example true
   */
  tossedUp: boolean;
  /**
   * Grupowanie duplikatów
   * @example true
   */
  groupDuplicate: boolean;
  /**
   * Data dodania od
   * Czas w formacie LocalDate
   * @format date
   * @example "2023-12-12"
   */
  offerAddedFrom: string;
  /**
   * Data dodania do
   * Czas w formacie LocalDate
   * @format date
   * @example "2023-12-12"
   */
  offerAddedTo?: string;
  /**
   * Ogłoszenia z liczby dni
   * @format int32
   * @example 7
   */
  daysAmount: number;
  sortType: SortType;
  unlockedAdvertisements: boolean;
  lowerOriginalPrice: boolean;
  /**
   * Pożądane numery telefonów
   * @example ["123467890"]
   */
  wantedPhoneNumbers?: string[];
  /**
   * Nie pożądane numery telefonów
   * @example ["123467890"]
   */
  unwantedPhoneNumbers?: string[];
  /** Rodzaj działki */
  buildingType?: PlotBuildingType[];
  timeRange: TimeRange;
  /**
   * Rodzaj raportu
   * @example ["Przedział czasu"]
   */
  reportType: ReportType[];
  /**
   * Granice przedziałów [m2]
   * @example "15,35,50,70,100,#"
   */
  boundaries: string;
}

export interface WebSaleFlatFilterDto {
  /**
   * Nazwa filtra
   * @example "Przykładowa nazwa filtra"
   */
  name: string;
  /**
   * Czas opóźnień powiadomień
   * @format int32
   * @default 0
   * @example 720
   */
  notificationsDelay: number;
  /**
   * Powiadomienia sms
   * @example true
   */
  alertSms: boolean;
  /**
   * Powiadomienia email
   * @example true
   */
  alertEmail: boolean;
  /**
   * Powiadomienia push
   * @example true
   */
  alertPush: boolean;
  locations: LocationDto[];
  module: Module;
  /**
   * Pożądane słowa kluczowe
   * Słowa kluczowa brane przy przeszukiwaniu opisu i tytułu
   * @example ["Mieszkanie"]
   */
  wantedKeywords?: string[];
  /**
   * Nie pożądane słowa kluczowe
   * Słowa kluczowa brane przy przeszukiwaniu opisu i tytułu
   * @example ["Mieszkanie"]
   */
  unwantedKeywords?: string[];
  /**
   * Powierzchnia nieruchomości od
   * @format double
   * @min 0
   * @example 100
   */
  areaFrom?: number;
  /**
   * Powierzchnia nieruchomości do
   * @format double
   * @min 0
   * @example 200
   */
  areaTo?: number;
  /**
   * Cena za metr kwadratowy od
   * @format double
   * @min 0
   * @example 100
   */
  pricePerSquareMeterFrom?: number;
  /**
   * Cena za metr kwadratowy do
   * @format double
   * @min 0
   * @example 200
   */
  pricePerSquareMeterTo?: number;
  /**
   * Cena nieruchomości od
   * @format double
   * @min 0
   * @example 1000000
   */
  priceFrom?: number;
  /**
   * Cena nieruchomości do
   * @format double
   * @min 0
   * @example 2000000
   */
  priceTo?: number;
  /** Od kogo pochodzi oferta */
  offerFrom?: OfferFrom[];
  /**
   * Wartości zerowe
   * @example true
   */
  includeZeroArea: boolean;
  /**
   * Modyfikacje ogłoszenia
   * @example true
   */
  modification: boolean;
  /**
   * Podbicie ogłoszenia
   * @example true
   */
  tossedUp: boolean;
  /**
   * Grupowanie duplikatów
   * @example true
   */
  groupDuplicate: boolean;
  /**
   * Data dodania od
   * Czas w formacie LocalDate
   * @format date
   * @example "2023-12-12"
   */
  offerAddedFrom: string;
  /**
   * Data dodania do
   * Czas w formacie LocalDate
   * @format date
   * @example "2023-12-12"
   */
  offerAddedTo?: string;
  /**
   * Ogłoszenia z liczby dni
   * @format int32
   * @example 7
   */
  daysAmount: number;
  sortType: SortType;
  unlockedAdvertisements: boolean;
  lowerOriginalPrice: boolean;
  /**
   * Pożądane numery telefonów
   * @example ["123467890"]
   */
  wantedPhoneNumbers?: string[];
  /**
   * Nie pożądane numery telefonów
   * @example ["123467890"]
   */
  unwantedPhoneNumbers?: string[];
  /**
   * Liczba pokoi w mieszkaniu od
   * @format int32
   * @min 0
   * @example 1
   */
  numberOfRoomsFrom?: number;
  /**
   * Liczba pokoi w mieszkaniu do
   * @format int32
   * @min 0
   * @example 3
   */
  numberOfRoomsTo?: number;
  /**
   * Rok budowy nieruchomości od
   * @format int32
   * @min 1800
   * @example 2012
   */
  builtYearFrom?: number;
  /**
   * Rok budowy nieruchomości do
   * @format int32
   * @max 2030
   * @example 2018
   */
  builtYearTo?: number;
  /** Typ marketu z którego pochodzi ogłoszenie */
  typeOfMarket?: TypeOfMarket[];
  /** Rodzaj budynku */
  buildingType?: FlatBuildingType[];
  /**
   * Piętro na którym jest mieszkanie od
   * @format int32
   * @example 4
   */
  floorFrom?: number;
  /**
   * Piętro na którym jest mieszkanie do
   * @format int32
   * @example 4
   */
  floorTo?: number;
  /**
   * Piętra w budynku od
   * @format int32
   * @example 4
   */
  floorsFrom?: number;
  /**
   * Piętra w budynku do
   * @format int32
   * @example 4
   */
  floorsTo?: number;
}

export interface WebSaleHouseFilterDto {
  /**
   * Nazwa filtra
   * @example "Przykładowa nazwa filtra"
   */
  name: string;
  /**
   * Czas opóźnień powiadomień
   * @format int32
   * @default 0
   * @example 720
   */
  notificationsDelay: number;
  /**
   * Powiadomienia sms
   * @example true
   */
  alertSms: boolean;
  /**
   * Powiadomienia email
   * @example true
   */
  alertEmail: boolean;
  /**
   * Powiadomienia push
   * @example true
   */
  alertPush: boolean;
  locations: LocationDto[];
  module: Module;
  /**
   * Pożądane słowa kluczowe
   * Słowa kluczowa brane przy przeszukiwaniu opisu i tytułu
   * @example ["Mieszkanie"]
   */
  wantedKeywords?: string[];
  /**
   * Nie pożądane słowa kluczowe
   * Słowa kluczowa brane przy przeszukiwaniu opisu i tytułu
   * @example ["Mieszkanie"]
   */
  unwantedKeywords?: string[];
  /**
   * Powierzchnia nieruchomości od
   * @format double
   * @min 0
   * @example 100
   */
  areaFrom?: number;
  /**
   * Powierzchnia nieruchomości do
   * @format double
   * @min 0
   * @example 200
   */
  areaTo?: number;
  /**
   * Cena za metr kwadratowy od
   * @format double
   * @min 0
   * @example 100
   */
  pricePerSquareMeterFrom?: number;
  /**
   * Cena za metr kwadratowy do
   * @format double
   * @min 0
   * @example 200
   */
  pricePerSquareMeterTo?: number;
  /**
   * Cena nieruchomości od
   * @format double
   * @min 0
   * @example 1000000
   */
  priceFrom?: number;
  /**
   * Cena nieruchomości do
   * @format double
   * @min 0
   * @example 2000000
   */
  priceTo?: number;
  /** Od kogo pochodzi oferta */
  offerFrom?: OfferFrom[];
  /**
   * Wartości zerowe
   * @example true
   */
  includeZeroArea: boolean;
  /**
   * Modyfikacje ogłoszenia
   * @example true
   */
  modification: boolean;
  /**
   * Podbicie ogłoszenia
   * @example true
   */
  tossedUp: boolean;
  /**
   * Grupowanie duplikatów
   * @example true
   */
  groupDuplicate: boolean;
  /**
   * Data dodania od
   * Czas w formacie LocalDate
   * @format date
   * @example "2023-12-12"
   */
  offerAddedFrom: string;
  /**
   * Data dodania do
   * Czas w formacie LocalDate
   * @format date
   * @example "2023-12-12"
   */
  offerAddedTo?: string;
  /**
   * Ogłoszenia z liczby dni
   * @format int32
   * @example 7
   */
  daysAmount: number;
  sortType: SortType;
  unlockedAdvertisements: boolean;
  lowerOriginalPrice: boolean;
  /**
   * Pożądane numery telefonów
   * @example ["123467890"]
   */
  wantedPhoneNumbers?: string[];
  /**
   * Nie pożądane numery telefonów
   * @example ["123467890"]
   */
  unwantedPhoneNumbers?: string[];
  /**
   * Liczba pokoi w domu od
   * @format int32
   * @min 0
   * @example 3
   */
  numberOfRoomsFrom?: number;
  /**
   * Liczba pokoi w domu do
   * @format int32
   * @min 0
   * @example 5
   */
  numberOfRoomsTo?: number;
  /**
   * Rok budowy nieruchomości od
   * @format int32
   * @min 1800
   * @example 2012
   */
  builtYearFrom?: number;
  /**
   * Rok budowy nieruchomości do
   * @format int32
   * @max 2030
   * @example 2018
   */
  builtYearTo?: number;
  /** Typ marketu z którego pochodzi ogłoszenie */
  typeOfMarket?: TypeOfMarket[];
  /** Rodzaj budynku */
  buildingType?: HouseBuildingType[];
  /**
   * Liczba pieter od
   * Pojedynczy wybór
   * @format int32
   * @example 0
   */
  floorFrom?: null;
  /**
   * Liczba pieter do
   * Pojedynczy wybór
   * @format int32
   * @example 2
   */
  floorTo?: null;
}

export interface WebSaleOtherFilterDto {
  /**
   * Nazwa filtra
   * @example "Przykładowa nazwa filtra"
   */
  name: string;
  /**
   * Czas opóźnień powiadomień
   * @format int32
   * @default 0
   * @example 720
   */
  notificationsDelay: number;
  /**
   * Powiadomienia sms
   * @example true
   */
  alertSms: boolean;
  /**
   * Powiadomienia email
   * @example true
   */
  alertEmail: boolean;
  /**
   * Powiadomienia push
   * @example true
   */
  alertPush: boolean;
  locations: LocationDto[];
  module: Module;
  /**
   * Pożądane słowa kluczowe
   * Słowa kluczowa brane przy przeszukiwaniu opisu i tytułu
   * @example ["Mieszkanie"]
   */
  wantedKeywords?: string[];
  /**
   * Nie pożądane słowa kluczowe
   * Słowa kluczowa brane przy przeszukiwaniu opisu i tytułu
   * @example ["Mieszkanie"]
   */
  unwantedKeywords?: string[];
  /**
   * Powierzchnia nieruchomości od
   * @format double
   * @min 0
   * @example 100
   */
  areaFrom?: number;
  /**
   * Powierzchnia nieruchomości do
   * @format double
   * @min 0
   * @example 200
   */
  areaTo?: number;
  /**
   * Cena za metr kwadratowy od
   * @format double
   * @min 0
   * @example 100
   */
  pricePerSquareMeterFrom?: number;
  /**
   * Cena za metr kwadratowy do
   * @format double
   * @min 0
   * @example 200
   */
  pricePerSquareMeterTo?: number;
  /**
   * Cena nieruchomości od
   * @format double
   * @min 0
   * @example 1000000
   */
  priceFrom?: number;
  /**
   * Cena nieruchomości do
   * @format double
   * @min 0
   * @example 2000000
   */
  priceTo?: number;
  /** Od kogo pochodzi oferta */
  offerFrom?: OfferFrom[];
  /**
   * Wartości zerowe
   * @example true
   */
  includeZeroArea: boolean;
  /**
   * Modyfikacje ogłoszenia
   * @example true
   */
  modification: boolean;
  /**
   * Podbicie ogłoszenia
   * @example true
   */
  tossedUp: boolean;
  /**
   * Grupowanie duplikatów
   * @example true
   */
  groupDuplicate: boolean;
  /**
   * Data dodania od
   * Czas w formacie LocalDate
   * @format date
   * @example "2023-12-12"
   */
  offerAddedFrom: string;
  /**
   * Data dodania do
   * Czas w formacie LocalDate
   * @format date
   * @example "2023-12-12"
   */
  offerAddedTo?: string;
  /**
   * Ogłoszenia z liczby dni
   * @format int32
   * @example 7
   */
  daysAmount: number;
  sortType: SortType;
  unlockedAdvertisements: boolean;
  lowerOriginalPrice: boolean;
  /**
   * Pożądane numery telefonów
   * @example ["123467890"]
   */
  wantedPhoneNumbers?: string[];
  /**
   * Nie pożądane numery telefonów
   * @example ["123467890"]
   */
  unwantedPhoneNumbers?: string[];
  /**
   * Rok budowy nieruchomości od
   * @format int32
   * @min 1800
   * @example 2012
   */
  builtYearFrom?: number;
  /**
   * Rok budowy nieruchomości do
   * @format int32
   * @max 2030
   * @example 2018
   */
  builtYearTo?: number;
  /**
   * Piętro od
   * @format int32
   * @example 4
   */
  floorFrom?: number;
  /**
   * Piętro do
   * @format int32
   * @example 4
   */
  floorTo?: number;
  /** Typ marketu z którego pochodzi ogłoszenie */
  typeOfMarket?: TypeOfMarket[];
  /** Rodzaj budynku */
  buildingType?: OtherBuildingType[];
}

export interface WebSalePlotFilterDto {
  /**
   * Nazwa filtra
   * @example "Przykładowa nazwa filtra"
   */
  name: string;
  /**
   * Czas opóźnień powiadomień
   * @format int32
   * @default 0
   * @example 720
   */
  notificationsDelay: number;
  /**
   * Powiadomienia sms
   * @example true
   */
  alertSms: boolean;
  /**
   * Powiadomienia email
   * @example true
   */
  alertEmail: boolean;
  /**
   * Powiadomienia push
   * @example true
   */
  alertPush: boolean;
  locations: LocationDto[];
  module: Module;
  /**
   * Pożądane słowa kluczowe
   * Słowa kluczowa brane przy przeszukiwaniu opisu i tytułu
   * @example ["Mieszkanie"]
   */
  wantedKeywords?: string[];
  /**
   * Nie pożądane słowa kluczowe
   * Słowa kluczowa brane przy przeszukiwaniu opisu i tytułu
   * @example ["Mieszkanie"]
   */
  unwantedKeywords?: string[];
  /**
   * Powierzchnia nieruchomości od
   * @format double
   * @min 0
   * @example 100
   */
  areaFrom?: number;
  /**
   * Powierzchnia nieruchomości do
   * @format double
   * @min 0
   * @example 200
   */
  areaTo?: number;
  /**
   * Cena za metr kwadratowy od
   * @format double
   * @min 0
   * @example 100
   */
  pricePerSquareMeterFrom?: number;
  /**
   * Cena za metr kwadratowy do
   * @format double
   * @min 0
   * @example 200
   */
  pricePerSquareMeterTo?: number;
  /**
   * Cena nieruchomości od
   * @format double
   * @min 0
   * @example 1000000
   */
  priceFrom?: number;
  /**
   * Cena nieruchomości do
   * @format double
   * @min 0
   * @example 2000000
   */
  priceTo?: number;
  /** Od kogo pochodzi oferta */
  offerFrom?: OfferFrom[];
  /**
   * Wartości zerowe
   * @example true
   */
  includeZeroArea: boolean;
  /**
   * Modyfikacje ogłoszenia
   * @example true
   */
  modification: boolean;
  /**
   * Podbicie ogłoszenia
   * @example true
   */
  tossedUp: boolean;
  /**
   * Grupowanie duplikatów
   * @example true
   */
  groupDuplicate: boolean;
  /**
   * Data dodania od
   * Czas w formacie LocalDate
   * @format date
   * @example "2023-12-12"
   */
  offerAddedFrom: string;
  /**
   * Data dodania do
   * Czas w formacie LocalDate
   * @format date
   * @example "2023-12-12"
   */
  offerAddedTo?: string;
  /**
   * Ogłoszenia z liczby dni
   * @format int32
   * @example 7
   */
  daysAmount: number;
  sortType: SortType;
  unlockedAdvertisements: boolean;
  lowerOriginalPrice: boolean;
  /**
   * Pożądane numery telefonów
   * @example ["123467890"]
   */
  wantedPhoneNumbers?: string[];
  /**
   * Nie pożądane numery telefonów
   * @example ["123467890"]
   */
  unwantedPhoneNumbers?: string[];
  /** Rodzaj działki */
  buildingType?: PlotBuildingType[];
}

export interface WebTenderFilterDto {
  /**
   * Nazwa filtra
   * @example "Przykładowa nazwa filtra"
   */
  name: string;
  /**
   * Czas opóźnień powiadomień
   * @format int32
   * @default 0
   * @example 720
   */
  notificationsDelay: number;
  /**
   * Powiadomienia sms
   * @example true
   */
  alertSms: boolean;
  /**
   * Powiadomienia email
   * @example true
   */
  alertEmail: boolean;
  /**
   * Powiadomienia push
   * @example true
   */
  alertPush: boolean;
  locations: LocationDto[];
  module: Module;
  /**
   * Pożądane słowa kluczowe
   * Słowa kluczowa brane przy przeszukiwaniu opisu i tytułu
   * @example ["Mieszkanie"]
   */
  wantedKeywords?: string[];
  /**
   * Nie pożądane słowa kluczowe
   * Słowa kluczowa brane przy przeszukiwaniu opisu i tytułu
   * @example ["Mieszkanie"]
   */
  unwantedKeywords?: string[];
  /**
   * Cena od
   * @format double
   * @example 250000
   */
  priceFrom?: number | null;
  /**
   * Cena do
   * @format double
   * @example 5500000
   */
  priceTo?: number | null;
  /**
   * Cena za m2 od
   * @format double
   * @example 2500
   */
  pricePerSquareMeterFrom?: number | null;
  /**
   * Cena za m2 od
   * @format double
   * @example 25000
   */
  pricePerSquareMeterTo?: number | null;
  /**
   * Powierzchnia od
   * @format double
   * @example 250.25
   */
  areaFrom?: number | null;
  /**
   * Powierzchnia do
   * @format double
   * @example 250.55
   */
  areaTo?: number | null;
  /** Typy nieruchomości */
  types?: TenderBuildingType[] | null;
  /**
   * Ogłoszenia z liczby dni
   * @format int32
   * @min 1
   * @example 3
   */
  daysAmount?: number | null;
  /**
   * Data dodania od
   * @format date
   * @example "2024-01-01"
   */
  dateAddedFrom?: string | null;
  /**
   * Data dodania do
   * @format date
   * @example "2024-01-04"
   */
  dateAddedTo?: string | null;
  /**
   * Akceptuj puste wartości
   * @example true
   */
  includeZeroArea?: boolean | null;
  sortType?: BaseSortType;
}

export type StreamingResponseBody = object;

export interface ChatPageDto {
  /** Lista wiadomości w konwersacji */
  newestChat?: ChatDetailDto;
  /**
   * Wiadomości
   * Lista wiadomości w konwersacji
   */
  oldestChat?: OldestChatMessageDto[];
}

/**
 * Wiadomości
 * Lista wiadomości w konwersacji
 */
export interface OldestChatMessageDto {
  /**
   * UUID konwersacji
   * Unikalny identyfikator
   * @format uuid
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  conversationUuid: string;
  /**
   * Tytuł wiadomości
   * Odpowiedź
   * @example "Wiadomość testowa"
   */
  title: string;
  /**
   * Czas utworzenia wiadomości
   * Czas utworzenia wiadomości
   * @format date-time
   */
  createdAt: string;
}

/**
 * Moduł ogłoszenia
 * Moduł, z którego pochodzi ogłoszenie
 * @example "SALE_FLAT"
 */
export enum SuggestedQuestionRequestDtoAdModuleEnum {
  AUCTION = "AUCTION",
  TENDER = "TENDER",
  BAILIFF_NOTICE = "BAILIFF_NOTICE",
  COOPERATIVE = "COOPERATIVE",
  RENT_FLAT = "RENT_FLAT",
  RENT_HOUSE = "RENT_HOUSE",
  RENT_OTHER = "RENT_OTHER",
  RENT_PLOT = "RENT_PLOT",
  SALE_FLAT = "SALE_FLAT",
  SALE_HOUSE = "SALE_HOUSE",
  SALE_OTHER = "SALE_OTHER",
  SALE_PLOT = "SALE_PLOT",
}

/**
 * Moduł/kategoria, z którego pochodzi ogłoszenie (np. SALE_FLAT, RENT_HOUSE)
 * @example "SALE_FLAT"
 */
export enum AdContextDtoAdModuleEnum {
  AUCTION = "AUCTION",
  TENDER = "TENDER",
  BAILIFF_NOTICE = "BAILIFF_NOTICE",
  COOPERATIVE = "COOPERATIVE",
  RENT_FLAT = "RENT_FLAT",
  RENT_HOUSE = "RENT_HOUSE",
  RENT_OTHER = "RENT_OTHER",
  RENT_PLOT = "RENT_PLOT",
  SALE_FLAT = "SALE_FLAT",
  SALE_HOUSE = "SALE_HOUSE",
  SALE_OTHER = "SALE_OTHER",
  SALE_PLOT = "SALE_PLOT",
}

/**
 * Moduł ogłoszenia
 * Moduł, z jakiego pochodzi ogłoszenie
 * @example "SALE_FLAT"
 */
export enum AdContextDetailsDtoAdModuleEnum {
  AUCTION = "AUCTION",
  TENDER = "TENDER",
  BAILIFF_NOTICE = "BAILIFF_NOTICE",
  COOPERATIVE = "COOPERATIVE",
  RENT_FLAT = "RENT_FLAT",
  RENT_HOUSE = "RENT_HOUSE",
  RENT_OTHER = "RENT_OTHER",
  RENT_PLOT = "RENT_PLOT",
  SALE_FLAT = "SALE_FLAT",
  SALE_HOUSE = "SALE_HOUSE",
  SALE_OTHER = "SALE_OTHER",
  SALE_PLOT = "SALE_PLOT",
}

/**
 * Właściciel wiadomości
 * Właściciel wiadomości
 * @example "USER_MESSAGE"
 */
export enum MessageResponseDtoMessageOwnerEnum {
  USER_MESSAGE = "USER_MESSAGE",
  BOT_MESSAGE = "BOT_MESSAGE",
}

export enum UploadDocumentsParamsCollectionEnum {
  CHATBOTV2 = "CHAT_BOT_V2",
  FLIPV3 = "FLIP_V3",
  FLIPWHOLESALEV2 = "FLIP_WHOLESALE_V2",
  DEVELOPERV2 = "DEVELOPER_V2",
  RENTIERV2 = "RENTIER_V2",
  MASTERMIND = "MASTERMIND",
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "http://192.168.31.12:8080";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== "string" ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
      body: typeof body === "undefined" || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title OpenAPI definition
 * @version v0
 * @baseUrl http://192.168.31.12:8080
 */
export class Api<SecurityDataType extends unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  chatbot = {
    /**
     * No description
     *
     * @tags Operacje związane z chatem
     * @name GetSuggestedQuestions
     * @summary Pobranie sugerowanych pytań dla bota
     * @request POST:/chatbot/questions/suggested
     * @secure
     */
    getSuggestedQuestions: (data: SuggestedQuestionRequestDto, params: RequestParams = {}) =>
      this.http.request<SuggestedQuestionCategoryDto, StreamingResponseBody>({
        path: `/chatbot/questions/suggested`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Operacje związane z chatem
     * @name GenerateMessageAudio
     * @summary Generowanie pliku audio z odpowiedzi bota na życzenie użytkownika
     * @request POST:/chatbot/message/{messageId}/audio/generate
     * @secure
     */
    generateMessageAudio: (messageId: number, params: RequestParams = {}) =>
      this.http.request<File, string>({
        path: `/chatbot/message/${messageId}/audio/generate`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Operacje związane z chatem
     * @name StreamAudioAnswer
     * @summary Generowanie odpowiedzi z chatu na podstawie głosu (STT + SSE)
     * @request POST:/chatbot/generate/stream/audio
     * @secure
     */
    streamAudioAnswer: (
      data: {
        /** @format binary */
        audio: File;
        data: ChatBotMessageDto;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<string, SseEmitter>({
        path: `/chatbot/generate/stream/audio`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Operacje związane z chatem
     * @name GenerateAnswer
     * @summary Generowanie odpowiedzi z chatu
     * @request POST:/chatbot/generate/answer
     * @secure
     */
    generateAnswer: (data: ChatBotMessageDto, params: RequestParams = {}) =>
      this.http.request<ChatDetailDto, StreamingResponseBody>({
        path: `/chatbot/generate/answer`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Operacje związane z dokumentami
     * @name UploadDocuments
     * @summary Upload plików .md do bazy wiedzy
     * @request POST:/chatbot/document/upload
     * @secure
     */
    uploadDocuments: (
      query: {
        collection: UploadDocumentsParamsCollectionEnum;
        apiKey: string;
      },
      data: {
        files: File[];
      },
      params: RequestParams = {},
    ) =>
      this.http.request<StreamingResponseBody, StreamingResponseBody>({
        path: `/chatbot/document/upload`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags test-controller
     * @name GetSchema
     * @request GET:/chatbot/test/schema
     * @secure
     */
    getSchema: (
      query: {
        className: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<StreamingResponseBody, any>({
        path: `/chatbot/test/schema`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Operacje związane z chatem
     * @name GetMessageAudio
     * @summary Pobieranie pliku audio dla konkretnej wiadomości (User STT lub Bot TTS)
     * @request GET:/chatbot/message/{messageId}/audio
     * @secure
     */
    getMessageAudio: (messageId: number, params: RequestParams = {}) =>
      this.http.request<File, string>({
        path: `/chatbot/message/${messageId}/audio`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Operacje związane z chatem
     * @name StreamMessageAudio
     * @summary Pobieranie i strumieniowanie audio w locie (jedno otwarte połączenie HTTP)
     * @request GET:/chatbot/message/{messageId}/audio/stream
     * @secure
     */
    streamMessageAudio: (messageId: number, params: RequestParams = {}) =>
      this.http.request<File, StreamingResponseBody>({
        path: `/chatbot/message/${messageId}/audio/stream`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Operacje związane z chatem
     * @name ChatHistory
     * @summary Historia pojedynczego chatu z chat-botem
     * @request GET:/chatbot/message/{conversationUuid}
     * @secure
     */
    chatHistory: (conversationUuid: string, params: RequestParams = {}) =>
      this.http.request<ChatDetailDto, StreamingResponseBody>({
        path: `/chatbot/message/${conversationUuid}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Operacje związane z chatem
     * @name ChatHistory1
     * @summary Historia chatu z chat-botem
     * @request GET:/chatbot/history
     * @secure
     */
    chatHistory1: (params: RequestParams = {}) =>
      this.http.request<ChatPageDto, StreamingResponseBody>({
        path: `/chatbot/history`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Operacje związane z chatem
     * @name StreamAnswer
     * @summary Generowanie odpowiedzi z chatu (Strumieniowanie SSE w czasie rzeczywistym via GET)
     * @request GET:/chatbot/generate/stream
     * @secure
     */
    streamAnswer: (
      query: {
        chatBotMessageDto: ChatBotMessageDto;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<string, SseEmitter>({
        path: `/chatbot/generate/stream`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Operacje związane z chatem
     * @name DeleteChatMessage
     * @summary Usunięcie pojedynczej konwersacji z chat-botem
     * @request DELETE:/chatbot/message/delete/{conversationUuid}
     * @secure
     */
    deleteChatMessage: (conversationUuid: string, params: RequestParams = {}) =>
      this.http.request<StreamingResponseBody, StreamingResponseBody>({
        path: `/chatbot/message/delete/${conversationUuid}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
}
